import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';

export class MonthlyPensionSourceJurisdiction implements Deserializable {
  public governingJurisdictionId!: GoverningJurisdictionTypeId | null;

  public onDeserialize(): void {}
}
